import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
const animations = {
  autoAlpha: {
    autoAlpha: 0,
  },

  y: {
    y: 50,
  },
};

function getAnimation(key) {
  return animations[key.trim()];
}

export function ScrollAnimation() {
  let sections = document.querySelectorAll(".section");
  let sectionsModel = [];

  function visibilityHandler([{ isIntersecting, target }]) {
    const id = target.getAttribute("id");

    const current = sectionsModel.find((section) => section.id === id);

    if (current) {
      current.isVisible = isIntersecting;
    }
  }

  const visibilityOptions = {
    threshold: 0.01,
    rootMargin: "-500px 0px 0px 1000px",
  };

  const sectionVisibilityObserver = new IntersectionObserver(
    visibilityHandler,
    visibilityOptions
  );

  if (!sections) {
    return;
  }

  sectionsModel = Array.from(sections).reduce((acc, $section) => {
    const id = $section.getAttribute("id");
    const $dots = $section.querySelectorAll(".dots");
    const { scrollTrigger } = $section.dataset;

    const innerScrollTriggers = Array.from(
      $section.querySelectorAll("[data-scroll-trigger]")
    ).reduce((acc, trigger) => {
      const children = Array.from(
        trigger.querySelectorAll("[data-scroll-animation]")
      );

      const updatedChildren = children.reduce((acc, children) => {
        const { stagger, scrollAnimation } = children.dataset;

        if (stagger !== undefined) {
          acc.push({
            animation: scrollAnimation
              .split(",")
              .map((key) => getAnimation(key)),

            staggers: Array.from(children.children).filter((c) => c.tagName),
          });

          return acc;
        }

        acc.push({
          animation: scrollAnimation.split(",").map((key) => getAnimation(key)),
          children,
        });

        return acc;
      }, []);
      acc.push({ trigger, children: updatedChildren });
      return acc;
    }, []);

    acc.push({
      id,
      isVisible: false,
      $section,
      isScrollTrigger: scrollTrigger,
      $dotsList: $dots,
      innerScrollTriggers,
      dots: Array.from($dots)
        .filter(($dot) => $dot.style.display !== "none")
        .map(($dot) => {
          let x = Math.random();

          while (x < 0.3) {
            x = Math.random();
          }

          return { $dot, x };
        }),
    });

    return acc;
  }, []);

  sectionsModel.forEach(({ $section, $dotsList, innerScrollTriggers }) => {
    sectionVisibilityObserver.observe($section);

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: $section,
        start: "0% 100%",
        end: "200% 0%",
        scrub: 1,
      },
    });

    tl.to($dotsList, { y: 350, duration: 0.5 });

    if (innerScrollTriggers) {
      innerScrollTriggers.forEach(({ trigger, children }) => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger,
            start: "top 95%",
            end: "110% 100%",
            scrub: 0.5,
          },
        });

        function updateAnimation(animation) {
          const animations = {};
          Object.values({
            ...animation.map((animation) => {
              return Object.entries(animation);
            }),
          }).forEach(([[key, value]]) => {
            animations[key] = value;
          });

          return animations;
        }

        children.forEach(({ animation, children, staggers }) => {
          if (staggers) {
            staggers.forEach(
              (stagger) => (stagger.style.willChange = "transform, opacity")
            );

            tl.from(
              staggers,
              {
                ...updateAnimation(animation),
                stagger: 2,
                duration: 10,
              },
              "-=6"
            );
          } else if (children) {
            children.style.willChange = "transform, opacity";
            tl.from(
              children,
              {
                ...updateAnimation(animation),
                duration: 10,
              },
              "-=6"
            );
          }
        });
      });
    }
  });

  window.addEventListener("mousemove", ({ clientX }) => {
    const visibleSection = sectionsModel.find(({ isVisible }) => isVisible);

    if (!visibleSection) {
      return;
    }

    visibleSection.dots.forEach(({ $dot, x }) => {
      let xValue = x < 0.5 ? -(clientX * x) / 30 : (clientX * x) / 30;

      gsap.to($dot, {
        x: xValue,
        duration: 1.3 - x,
      });
    });
  });
}
